export default "/assets/images/app-update-img-05.5beb7a9fcccb4122.webp";